module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-thunder-cb24f7053f06d3a11258ec3617c0cb40.svg";